module.exports = __webpack_public_path__ + "static/media/user.8334cd76.png";